import type { IMarketingChannelsFilterDto } from "app/pages/sales-intelligence/modules/leads-search-filters";
import type { ColumnByKeys } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/column-by-keys";
import type { SuggestedColumnName } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/columns";
import { processColumnsByKeys } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/utils/processColumnsByKeys";

import * as columnNames from "../../constants/column-names";

const COLUMNS_BY_KEYS: ColumnByKeys<IMarketingChannelsFilterDto> = {
    directShare: [
        columnNames.DIRECT_VISITS_SHARE_FIELD,
        columnNames.DIRECT_VISITS_CHANGE_MOM_FIELD,
        columnNames.DIRECT_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_DIRECT_VISITS_FIELD,
    ],
    displayAdsShare: [
        columnNames.DISPLAYADS_VISITS_SHARE_FIELD,
        columnNames.DISPLAYADS_VISITS_CHANGE_MOM_FIELD,
        columnNames.DISPLAYADS_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_DISPLAYADS_VISITS_FIELD,
    ],
    emailShare: [
        columnNames.MAIL_VISITS_SHARE_FIELD,
        columnNames.MAIL_VISITS_CHANGE_MOM_FIELD,
        columnNames.MAIL_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_MAILS_VISITS_FIELD,
    ],
    organicSearchShare: [
        columnNames.ORGANIC_SEARCH_VISITS_SHARE_FIELD,
        columnNames.ORGANIC_SEARCH_VISITS_CHANGE_MOM_FIELD,
        columnNames.ORGANIC_SEARCH_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_ORGANIC_SEARCH_VISITS_FIELD,
    ],
    paidSearchShare: [
        columnNames.PAID_SEARCH_VISITS_SHARE_FIELD,
        columnNames.PAID_SEARCH_VISITS_CHANGE_MOM_FIELD,
        columnNames.PAID_SEARCH_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_PAID_SEARCH_VISITS_FIELD,
    ],
    referralsShare: [
        columnNames.REFERRALS_VISITS_SHARE_FIELD,
        columnNames.REFERRALS_VISITS_CHANGE_MOM_FIELD,
        columnNames.REFERRALS_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_REFERRALS_VISITS_FIELD,
    ],
    socialShare: [
        columnNames.SOCIAL_VISITS_SHARE_FIELD,
        columnNames.SOCIAL_VISITS_CHANGE_MOM_FIELD,
        columnNames.SOCIAL_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_SOCIAL_VISITS_FIELD,
    ],
    organicSocialShare: [
        columnNames.ORGANIC_SOCIAL_VISITS_SHARE_FIELD,
        columnNames.ORGANIC_SOCIAL_VISITS_CHANGE_MOM_FIELD,
        columnNames.ORGANIC_SOCIAL_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_ORGANIC_SOCIAL_VISITS_FIELD,
    ],
    paidSocialShare: [
        columnNames.PAID_SOCIAL_VISITS_SHARE_FIELD,
        columnNames.PAID_SOCIAL_VISITS_CHANGE_MOM_FIELD,
        columnNames.PAID_SOCIAL_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_PAID_SOCIAL_VISITS_FIELD,
    ],
    genAiShare: [
        columnNames.GEN_AI_VISITS_SHARE_FIELD,
        columnNames.GEN_AI_VISITS_CHANGE_MOM_FIELD,
        columnNames.GEN_AI_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_GEN_AI_VISITS_FIELD,
    ],
    affiliateShare: [
        columnNames.AFFILIATE_VISITS_SHARE_FIELD,
        columnNames.AFFILIATE_VISITS_CHANGE_MOM_FIELD,
        columnNames.AFFILIATE_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_AFFILIATE_VISITS_FIELD,
    ],
    searchShare: [
        columnNames.SEARCH_VISITS_SHARE_FIELD,
        columnNames.SEARCH_VISITS_CHANGE_MOM_FIELD,
        columnNames.SEARCH_VISITS_CHANGE_YOY_FIELD,
        columnNames.LAST_MONTHS_SEARCH_VISITS_FIELD,
    ],
};

const processMarketingChannelsFilter = (filterDto: Partial<IMarketingChannelsFilterDto>): readonly SuggestedColumnName[] => {
    return processColumnsByKeys<IMarketingChannelsFilterDto>(filterDto, COLUMNS_BY_KEYS);
};

export default processMarketingChannelsFilter;
